import React, { useState } from "react";
import { useTranslation } from "next-export-i18n";
import Image from "next/image";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperClass, { Navigation } from "swiper";

import testimonial_slider_img_1 from "@assets/img/testimonial/logo-nova.png";
import testimonial_slider_img_2 from "@assets/img/testimonial/logo-duo.png";
import testimonial_slider_img_3 from "@assets/img/testimonial/logo-mkt.png";
import testimonial_shape_1 from "@assets/img/testimonial/home-3/shape-1.png";
import testimonial_shape_2 from "@assets/img/testimonial/home-3/shape-2.png";
import LineArrow from "@/src/svg/line-arrow-2";
import SliderIndicatorEmpty from "@assets/img/home/slider-indicator-empty.svg";
import SliderIndicatorFull from "@assets/img/home/slider-indicator-full.svg";

const TestimonialArea = () => {
    const { t } = useTranslation();

    const [swiper, setSwiper] = useState<SwiperClass>();
    const [currentSlide, setCurrentSlide] = useState(0);

    const handleSlideTo = (index: number) => () => swiper!.slideToLoop(index);
    const handleSlideChange = (swiper: SwiperClass) =>
        setCurrentSlide(swiper?.realIndex);

    const sliderData = [
        {
            id: 0,
            image: testimonial_slider_img_1,
            text: t("home.testimonials.testimonial_1.full_text"),
            name: "Alex Vinikov",
            title: t("home.testimonials.testimonial_1.title"),
            company: "Nova Media",
            link: "https://www.novamedia.co.il/",
        },
        {
            id: 1,
            image: testimonial_slider_img_2,
            text: t("home.testimonials.testimonial_2.full_text"),
            name: "Julio Aguayo",
            title: t("home.testimonials.testimonial_2.title"),
            company: "Duo Advertising",
            link: "https://www.duoadvertising.com/",
        },
        {
            id: 2,
            image: testimonial_slider_img_3,
            text: t("home.testimonials.testimonial_3.full_text"),
            name: "Mariela Fernande",
            title: t("home.testimonials.testimonial_3.title"),
            company: "MKT",
            link: "https://www.mktintelligence.net/",
        },
    ];

    const settings = {
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
    };

    return (
        <>
            <section className="tp-testimonial-3-area pb-120 mt-50">
                <div className="tp-testimonial-3-shape">
                    <Image
                        className="shape-1"
                        src={testimonial_shape_1}
                        alt="theme-pure"
                    />
                    <Image
                        className="shape-2"
                        src={testimonial_shape_2}
                        alt="theme-pure"
                    />
                </div>
                <div className="tp-testimonial-3-large-box">
                    <div className="container">
                        <div className="col-lg-12 mb-50">
                            <div className="partners-title-wrapper text-center">
                                <h3 className="tp-section-title partners tp-portfolio-title">
                                    {t("home.testimonials.title.primary")}
                                    <span className="partners-title-secondary">
                                        {t("home.testimonials.title.secondary")}
                                    </span>
                                    <span className="partners_center-shape testimonials-shape">
                                        <LineArrow />
                                    </span>
                                </h3>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xl-5 col-lg-4">
                                <div className="tp-testimonial-3-wrapper">
                                    <div className="tp-testimonial-3-wrapper-thumb p-relative">
                                        <div className="mb-30">
                                            <Image
                                                className="slide"
                                                src={
                                                    sliderData[currentSlide]!
                                                        .image
                                                }
                                                alt="theme-pure"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-7 col-lg-8">
                                <div className="tp-testimonial-3-content">
                                    {/* @ts-ignore */}
                                    <Swiper
                                        {...settings}
                                        modules={[Navigation]}
                                        className="about-active swiper-container"
                                        onSlideChange={handleSlideChange}
                                        onSwiper={setSwiper}
                                    >
                                        {sliderData.map((item, i) => (
                                            <SwiperSlide
                                                key={i}
                                                className="mb-30"
                                            >
                                                <div className="tp-testimonial-3-slider-wrapper">
                                                    <p>{item!.text}</p>
                                                </div>
                                            </SwiperSlide>
                                        ))}
                                    </Swiper>
                                    <div className="tp-testimonial-3-descreiption text-end text-sm-end">
                                        <h4 className="testimonial-title">
                                            {sliderData[currentSlide]!.name}
                                        </h4>
                                        <p>
                                            {sliderData[currentSlide]!.title}{" "}
                                            {t("home.testimonials.at")}{" "}
                                            <a
                                                href={
                                                    sliderData[currentSlide]!
                                                        .link
                                                }
                                                target="_blank"
                                            >
                                                <span>
                                                    {
                                                        sliderData[
                                                            currentSlide
                                                        ]!.company
                                                    }
                                                </span>
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="d-flex justify-content-center mt-20 tp-testimonial-dots">
                            {sliderData.map((item) => (
                                <button
                                    key={`testimonials-slider-dot-${item.id}`}
                                    onClick={handleSlideTo(item.id)}
                                >
                                    <Image
                                        src={
                                            item.id === currentSlide
                                                ? SliderIndicatorFull
                                                : SliderIndicatorEmpty
                                        }
                                        alt="theme-pure"
                                    />
                                </button>
                            ))}
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default TestimonialArea;
